import React from 'react';
import ProductLogo from './ProductLogo';
import Button from './Button';

export default function AiHeroSection({styles, handleActivateClick, config}) {
  return (
   <section className={styles.heroSection}>
          <div className={styles.container}>
            <div className={styles.heroContent}>
              <div className={`${styles.heroText} half-width`}>
                <div className={styles.iconProductName}>
                  <ProductLogo product={"attribution"} size={32} />
                  <span className={styles.productName}>Instant AI</span>
                </div>
                <div className={styles.heroTitleContainer}>
                  <h1 className={styles.heroTitle}>
                    AI-powered marketing emails tailored to each shopper
                  </h1>
                  <p className={styles.heroSubtitle}>
                    Instant AI builds, sends, and continually optimizes
                    high-performing emails flows personalized to every shopper.
                  </p>
                </div>
                <Button onClick={handleActivateClick}> {config.text}</Button>
              </div>
              <div className={`${styles.heroImage} half-width`}>
                <video
                  src="/images/aiHeroShopper.mp4"
                  autoPlay
                  muted
                  loop
                  playsInline
                  alt="Attribution Analytics Preview"
                />
              </div>
            </div>
          </div>
        </section>
  );
}